import { Separator } from '@frontend/shadcn/components/ui/separator';
import React from 'react';
import { Accordion } from '@frontend/shadcn/components/ui/accordion';
import { useAmplifyHomePage } from '../RecruitmentContext';
import { AmplifyHeroSection } from './AmplifyHeroSection';
import { AmplifyAboutSection } from './AmplifyAboutSection';
import { AmplifyPerksSection } from './AmplifyPerksSection';
import { AmplifyPersonaSection } from './AmplifyPersonaSection';
import { AmplifyFormSection } from './AmplifyFormSection';

export const AmplifyHomePage = () => {
  const homePage = useAmplifyHomePage();

  if (!homePage) {
    return null;
  }

  return (
    <Accordion type="multiple" className="[&_h3]:mb-0" defaultValue={['hero', 'about', 'perks', 'persona', 'form']}>
      <AmplifyHeroSection />
      <Separator />
      <AmplifyAboutSection />
      <Separator />
      <AmplifyPerksSection />
      <Separator />
      <AmplifyPersonaSection />
      <Separator />
      <AmplifyFormSection />
    </Accordion>
  );
};
